import { render, staticRenderFns } from "./RightsFundDeductCopy.vue?vue&type=template&id=d821c696"
import script from "./RightsFundDeductCopy.vue?vue&type=script&lang=js"
export * from "./RightsFundDeductCopy.vue?vue&type=script&lang=js"
import style0 from "./RightsFundDeductCopy.vue?vue&type=style&index=0&id=d821c696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports